import { UNCONTROLLED_ERROR } from 'common/constants/messages/validations';
import { QUESTION_ANSWERED_SUCCESSFULLY } from 'common/constants/process-management';
import TasksService from 'services/tasks';
import { useResponse } from './useResponse';

export const useTasks = () => {
  const tasksService = new TasksService();
  const { errorNotification, successNotification } = useResponse();

  const validateQuestionnairesRequestToken = async (requestId: string, token: string) => {
    try {
      const response = await tasksService.validateQuestionnairesRequestToken(requestId, token);
      return response;
    } catch (error) {
      return error;
    }
  };

  const updateQuestionnaireRequestToken = async (requestId: string, hmacToken: string, questionData: unknown) => {
    try {
      const response = await tasksService.updateQuestionnaireRequestToken(requestId, hmacToken, questionData);
      if (response.answer) {
        successNotification(QUESTION_ANSWERED_SUCCESSFULLY);
      }
    } catch (error) {
      errorNotification(UNCONTROLLED_ERROR);
    }
  };

  const getQuestionOptions = async () => {
    try {
      const response = await tasksService.getQuestionOptions();
      return response;
    } catch (error) {
      errorNotification(UNCONTROLLED_ERROR);
    }
  };

  return {
    validateQuestionnairesRequestToken,
    updateQuestionnaireRequestToken,
    getQuestionOptions,
  };
};

export default useTasks;
